import { DEFAULT_SESSION_VALUE, LIFETIME_SAVINGS_NUDGE_LIMIT, STORAGE_KEYS } from "@super-ui/constants";

import { isEmpty } from "@swiggy-private/js-utils";

import { GlobalHeaderState } from "@swiggy-private/checkout-core";
import { SwgyHeaderKeysList } from "@swiggy-private/core-types";

/**
 * This function checks for he mileStone, for the same mileStone it calls the session logic with parameters `key:string` `currentSid: string`
 * @param key - key to be used for local storage for session `active/expired`
 * @param milestone - milestone to be checked
 * @param currentSid - current session id
 */
export function checkAndUpdateLifetimeSavings(key: string, milestone: string) {
    try {
        const currentSid = GlobalHeaderState.getHeader(SwgyHeaderKeysList.sid) || "0";
        const savedMilestone = localStorage.getItem(STORAGE_KEYS.LIFETIME_SAVINGS_NUDGE_MILESTONE) || "";

        if (isEmpty(savedMilestone) || savedMilestone !== milestone) {
            // Reset keys and values
            localStorage.setItem(key, DEFAULT_SESSION_VALUE);
            localStorage.setItem(STORAGE_KEYS.LIFETIME_SAVINGS_NUDGE_MILESTONE, milestone);
        }

        // Call function with key as parameter and return the boolean result
        return checkSessionIdOrFrequency(key, currentSid);
    } catch {
        return false;
    }
}

/**
 * This function checks and updates the session and frequency
 * @param key - key to be used for local storage
 * @param currentSid - current session id
 */
export function checkSessionIdOrFrequency(key: string, currentSid: string) {
    try {
        const { frequency, sessionId } = JSON.parse(localStorage.getItem(key) || DEFAULT_SESSION_VALUE);

        if (!isEmpty(sessionId) && sessionId === currentSid) {
            return true;
        } else if (frequency <= LIFETIME_SAVINGS_NUDGE_LIMIT) {
            // Update frequency and return true
            const updatedSessionData = { frequency: frequency + 1, sessionId: currentSid };
            localStorage.setItem(key, JSON.stringify(updatedSessionData));
            return true;
        }

        // Frequency limit exceeded, return false
        return false;
    } catch {
        return false;
    }
}
